import {observer} from 'mobx-react-lite'
import React from 'react'
import ReactDOM from 'react-dom'
import tw from 'tailwind-styled-components'
import {DoneCounterView} from '@components/common/sandbox/list-view/components/done-counter'
import {useListStore} from '@components/common/sandbox/list-view/list-store'

const TwContainer = tw.div<{$visible?: boolean}>`
  flex
  items-center
  gap-6
  pl-8
  py-8
  pr-24
  rounded-8
  bg-background-hover
  shadow-sm-list
  display
  ${props => (props.$visible ? `flex` : `hidden`)}
`

const TwCircle = tw.div`
  w-20
  h-20
  mr-8
  border-icon-secondary
  border-1
  border-solid
  rounded-full
`

const TwText = tw.div`
  text-primary
  text-body
  truncate
  max-w-[560px]
`

export const DragGhost = observer(() => {
  const store = useListStore()
  const {visible, text, totalCount = 0, doneCount = 0} = store.dragGhost
  return ReactDOM.createPortal(
    <TwContainer $visible={visible} ref={store.setDragGhostElement}>
      <TwCircle />
      {totalCount > 0 ? (
        <DoneCounterView doneCount={doneCount} totalCount={totalCount} />
      ) : null}
      <TwText>{text}</TwText>
    </TwContainer>,
    document.body
  )
})
